import { createApi } from '@reduxjs/toolkit/query/react'
import { CREATE_SCHOOL, LIST_SCHOOL, REMOVE_SCHOOL, RESEND_CLIENT_REPORT, SCHOOL_BANNERS_CREATE, SCHOOL_BANNERS_DELETE, SCHOOL_BANNERS_FAVORITE, SCHOOL_BANNERS_LIST, SCHOOL_BANNERS_UPDATE, SCHOOL_BANNERS_VIEW, UPDATE_SCHOOL, VIEW_SCHOOL } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { schoolDivisonsApi } from "./schoolsDivisons"
import { invalidateAPITags } from "utils/common"

export const schoolBannersApi = createApi({
  reducerPath: 'schoolBannersApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/school-banners",
  }),
  tagTypes: ["SchoolsBanners"],
  endpoints: (builder) => ({
    // get Schools list
    getSchoolBannersList: builder.query({
      query: ({ search = "", status = "",sort, page = 1, limit = 10, }) => {
        return ({
          method: "PATCH",
          url: SCHOOL_BANNERS_LIST,
          data: {
            search,
            // status: status ? status?.value : "",
            page,
            limit,
            sort
          },
        })
      },
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["SchoolsBanners"]
    }),

    // get School profile
    viewSchoolBanner: builder.query({
      query: ({id}) => ({
        method: "GET",
        url: `${SCHOOL_BANNERS_VIEW}/${id}`
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ["SchoolsBanners"]
    }),

    // create School profile
    createSchoolBanner: builder.mutation({
      query: ({data}) => ({
        method: "POST",
        url: SCHOOL_BANNERS_CREATE,
        data
      }),
      invalidatesTags: ["SchoolsBanners"],
    }),

    // update School profile
    updateSchoolBanner: builder.mutation({
      query: ({id, data}) => ({
        method: "PUT",
        url: `${SCHOOL_BANNERS_UPDATE}/${id}`,
        data: data
      }),
      invalidatesTags: ["SchoolsBanners"],
    }),

    favoriteSchoolBanner: builder.mutation({
      query: ({id, data}) => ({
        method: "PATCH",
        url: `${SCHOOL_BANNERS_FAVORITE}/${id}`,
        data: data
      }),
      invalidatesTags: ["SchoolsBanners"],
    }),

  
    // delete School profile
    deleteSchoolBanner: builder.mutation({
      query: ({id}) => ({
        method: "DELETE",
        url: `${SCHOOL_BANNERS_DELETE}/${id}`
      }),
      invalidatesTags: ["SchoolsBanners"],
    }),
  }),
})

export const {
  useGetSchoolBannersListQuery,
  useCreateSchoolBannerMutation,
  useViewSchoolBannerQuery,
  useUpdateSchoolBannerMutation,
  useDeleteSchoolBannerMutation,
  useFavoriteSchoolBannerMutation,
  useLazyGetSchoolBannersListQuery, 
} = schoolBannersApi;